import React from "react";
import '../styles/sections/headingWithGrid.scss';
// import {Link} from 'react-router-dom';

function HeadingWithGrid(props) {
    const data = props.data;    
    const listClasses = (data.theme !== '' && data.theme !== undefined ? data.theme : '') + ' ' + (data.columns === 3 ? 'threeCols' : '');
    
    return (
        <div className="headingWithGrid">
            <div className="innerBox">
                <h3 className="sectionHeading">{ data.title }</h3>
                <ul className={listClasses}>
                    {data.blocks.map((d, index)=>
                        <li key={index}>
                            {/*<Link to={d.url}>*/}
                                <img src={d.src} alt={d.title} />
                                <h6>{d.title}</h6>
                            {/*</Link>*/}
                        </li>
                    )}
                </ul>
            </div>
        </div>
    )
}

export default HeadingWithGrid;